import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getDavidConfig = (t: TranslateFunction): GiveawayConfig => {
  return createBaseConfig({
    theatricalSlug: slugs.david,
    heroTitle: t('giveawayHeroTitleDavid', 'Experience David and Win Life-changing Prizes!'),
    logoUrl: angelImagesUrl('v1760128236/david/2025_FINAL_David_1-Color_WHT_TT.webp'),
    footerLogoUrl: angelImagesUrl('v1760128236/david/2025_FINAL_David_1-Color_WHT_TT.webp'),
    inTheatersText: t('inTheatersDavid', 'In theaters December 19, 2025'),
    videoImage: angelImagesUrl('v1759509000/david/trailer-tumbnail.webp'),
    releaseDate: 'December 19, 2025',
    backgroundVideoUrl:
      'https://content.angelstudios.com/david/David_tLoopingVideo_l-en_wNOCAPS_16x9_f23_y20251013_iDG.mp4',
    share: {
      shareText:
        'The upcoming @AngelStudios movie David in theaters on Dec. 19th. Preorder tickets for a chance to win the David Christmas Tour Giveaway!',
      hashtag: '#DavidGiveaway',
      shareImage: angelImagesUrl(
        'v1761167908/david/david-film_Still_2025-07-09_130155_Tone_Mapped_100-nit_BT.709_BT.1886__1.4.1_1_1.webp',
      ),
      shareImageMobile: angelImagesUrl(
        'v1761167908/david/david-film_Still_2025-07-09_130155_Tone_Mapped_100-nit_BT.709_BT.1886__1.4.1_1_1.webp',
      ),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.david,
      congratsKey: 'davidCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the David Christmas Tour Giveaway! Complete your checkout to secure your entries.",
      portraitImage: staticAssetUrl('v1762983695/david/DAVID-giveaway'),
      reservationKey: 'davidReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the David Christmas Tour Giveaway!",
      noShowtimesKey: 'davidNoShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, preorder tickets today for your chance to win the David Christmas Tour Giveaway!",
      landscapeImage: staticAssetUrl(
        'v1761167908/david/david-film_Still_2025-07-09_130155_Tone_Mapped_100-nit_BT.709_BT.1886__1.4.1_1_1.webp',
      ),
    }),

    steps: [
      {
        title: t('preOrderTicketsV2', 'Preorder Tickets'),
        description: t('DavidChooseYourTickets', 'Choose your tickets to David below.'),
      },
      {
        title: t('receiveYourPromoCodes', 'Receive Your Promo Codes'),
        description: t(
          'eachTicketEarnsAPromoCode',
          'Each ticket earns you a unique promo code (redeemable when showtimes are available).',
        ),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'theMoreTicketsYouBuy',
          'The more tickets you buy, and the earlier you buy them, the greater your entry multiplier, boosting your odds of winning!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [],
    partnerLogos: [],
  })
}
